var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.valid)?_c('div',{staticClass:"validation-item"},[_c('div',{staticClass:"bullet-icon-container"},[_c('BulletIcon',{staticClass:"bullet-icon"})],1),_c('span',[_vm._v(_vm._s(_vm.text))])]):_c('div',{staticClass:"validation-item valid"},[_c('CheckIcon',{staticClass:"check-icon"}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }